import httpClient from '@/lib/httpClient.js'
import { useQuery } from '@tanstack/react-query'

export default function useGetIsEmptyCategory(id) {
  const fetchData = async () => {
    const response = await httpClient.get(
      `/team/transaction-category/${id}/is-empty`,
    )
    return response.data.data
  }

  return useQuery({
    queryKey: ['is-empty-category', id],
    queryFn: fetchData,
    enabled: !!id,
  })
}
